import {Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractControl, UntypedFormControl} from '@angular/forms';
import * as _ from 'lodash';

/**
 * Component for multiselect fields
 */
@Component({
  selector: '[app-form-field-multiselect]',
  templateUrl: './form-field-multiselect.component.html',
})
export class FormFieldMultiselectComponent implements OnInit, OnDestroy {
  @HostBinding('class.esf-form-item')
  public get formItemClass(): boolean {
    return true;
  }

  public lodash = _;

  @Input() public optional: boolean = false;
  @Input() public multiselectData: Array<any> = [];
  @Input() public label: string = '';
  @Input() public bindValue: any = 'name';
  @Input() public bindLabel: any = 'name';
  @Input() public control: AbstractControl;
  @Input() public id: string;

  @Output() public valueChanged: EventEmitter<any> = new EventEmitter<any>(null);

  constructor() {
  }

  get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }

  public ngOnInit(): void {
    if (this.control) {
      const parent = this.control?.parent;
      for (const key of Object.keys(parent.controls)) {
        const childControl = this.lodash.get(parent.controls, key);
        if (childControl === this.control) {
          this.id = key;
        }
      }
    }
  }

  public ngOnDestroy(): void {
  }

  /**
   * Emits the value that was selected
   */
  onChange(event: any): void {
    this.valueChanged.emit(event.target.value);
  }

}
